export default __webpack_public_path__ + "static/media/Mic_Off.34b25d30.svg";